import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource/golos-text/400.css'
import '@fontsource/golos-text/500.css'
import '@fontsource/golos-text/600.css'
import '@/styles/global.css'
import { App } from '@/app/App'
import { StageBadge } from '@/components/stage/StageBadge'
import { TooltipProvider } from '@/components/Tooltip'
import { appTitle, isStaging } from '@/lib/stage'
import { catchReferral } from '@/lib/referral'
import { catchCampaign, trackVisit } from '@/lib/campaign'
import { captureMetrikaCampaign } from '@/lib/metrika'
import { preventInputZoom } from '@/lib/mobile'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 60_000 } },
})

// пришли по ссылке-приглашению — забираем код из адреса до первой отрисовки
captureMetrikaCampaign()
catchReferral()
catchCampaign()
trackVisit(window.location.pathname)

document.title = appTitle
preventInputZoom()

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <TooltipProvider />
      {isStaging ? <StageBadge /> : null}
    </QueryClientProvider>
  </StrictMode>,
)
